import React from 'react'


function Todolist(props) {
    return (
        <div className='taskwrap'>
           <div className='items'>
               <div className='mytask' style={{background:props.color}}>
               {props.task} 
               
               </div>
               <div className='delete' onClick={props.del} >X</div>
           </div>
          
        </div>
    )
}

export default Todolist
